export { default as WealthPlaybookDomainMiniDisplay } from "./WealthPlaybookDomainMiniDisplay";
